import React from 'react'
import SimpleBanner from '../../components/common/SimpleBanner'
import PortfoioHero from './PortfoioHero'

const Portfolio = () => {
  return (
    <div>
        <SimpleBanner title="Portfolio" subHeading="Home > Portfolio" />
        <PortfoioHero/>
    </div>
  )
}

export default Portfolio